import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Room Type: A classification of rooms based on their usage (e.g., wet lab, lecture hall, conference room).',
    name: 'Room Types',
    partialId: PartialId.Standard.create('room_types'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
